import { useAuthStore } from '../auth/store';
import { ProfileTab } from './settings/ProfileTab';
import './SettingsPage.css';

// The per-user settings surface reached from the topbar gear/username.
// Scoped to the signed-in user only (avatar, password, 2FA); the
// application/system settings live in the admin hub (SettingsPage at
// /system-settings). Both render the shared <ProfileTab>.
export function UserSettingsPage(): JSX.Element {
  const me = useAuthStore((s) => s.me)!;
  return (
    <section className="page-stack page-stack-wide">
      <div className="card set-toolbar">
        <h2 className="set-toolbar-heading">User Settings</h2>
      </div>
      <ProfileTab email={me.user.email} />
    </section>
  );
}
